const documents = {
  title: "Dokumente",
  list: {
    empty: "Keine Dokumente vorhanden",
    fileName: "Dateiname",
    fileSize: "Größe",
    contentType: "Dateityp",
    assignedAt: "Zugewiesen am",
    assignedBy: "Zugewiesen von",
    download: "Herunterladen",
    delete: "Löschen",
    deleteConfirmTitle: "Dokument löschen",
    deleteConfirm:
      'Möchten Sie das Dokument "{{fileName}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteSuccess: "Dokument erfolgreich gelöscht",
    deleteError: "Fehler beim Löschen des Dokuments",
    downloadError: "Fehler beim Herunterladen des Dokuments",
  },
  assign: {
    button: "Dokument zuweisen",
    title: "Dokument aus DropZone zuweisen",
    success: "Dokument erfolgreich zugewiesen",
    error: "Fehler beim Zuweisen des Dokuments",
    confirm: "Zuweisen",
    selectFile: "Datei auswählen",
    noFiles: "Keine Dateien in der DropZone vorhanden",
  },
};

export default documents;
